import { ReportColumns } from '@/pages/Reports/DynamicReport/components/ReportTable/utils';
import { TrainingReportCity, formatZero } from '@/features/PdfLayout/layouts/TrainingReport/utils';

// `attemptId` only feeds the on-screen Evaluation Summary drill-down, never shown
const HIDDEN_COLUMNS = ['attemptId', 'trainers'];

export const visibleColumns = (columns: ReportColumns = {}): string[] =>
  Object.keys(columns).filter((key) => !HIDDEN_COLUMNS.includes(key));

// Empty values fall through to ReportTableCell's "--" placeholder
export const formatValue = (value?: string): string | null => (value ? formatZero(value) : null);

// Prefer the column named "driver"; fall back to the first column, which is the driver name in the design
const findDriverColumn = (columns: ReportColumns = {}): string | undefined => {
  const keys = Object.keys(columns);
  return keys.find((key) => /^driver/i.test(key) || /^driver/i.test(String(columns[key]?.value ?? ''))) ?? keys[0];
};

// A driver trained several times appears in several rows (and possibly several cities),
// so Total Employees is the number of distinct driver names, not the number of rows
export const countUniqueDrivers = (cities: TrainingReportCity[] = []): number => {
  const drivers = new Set<string>();
  cities.forEach(({ childColumns, drivers: rows }) => {
    const driverColumn = findDriverColumn(childColumns);
    rows.forEach((values) => {
      const name = values?.[driverColumn]?.trim().replace(/\s+/g, ' ');
      if (name) drivers.add(name.toLowerCase());
    });
  });
  return drivers.size;
};
